<template>
    <div class="msg_container" :class="msgItem.isme ? 'me' : 'others'">
        <div class="flex_center  card_item">
            <div class="avatar">
                <img :src="msgItem.avatar" />
            </div>

            <div>
                <div class="card_uname">
                    <i v-if="msgItem.isme  && msgItem.is_aichat == 1"
                        class="iconfont icon-zhinengkefuzhongxin m_ai_icon"></i>
                    {{ msgItem.author }}
                </div>

                <div class="card_content_container">
                    <div v-if="msgItem.isme">
                        <div class="lds-ring" v-if="msgItem.send_status == 2">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <div v-else-if="msgItem.send_status === 0">
                            <el-popover placement="top-start" :width="200" trigger="hover" :content="msgItem.error_msg">
                                <template #reference>
                                    <i class="iconfont icon-Shapex" style="color:red"></i>
                                </template>
                            </el-popover>
                        </div>
                    </div>


                    <div class="card_content">
                        <component :is="cards[`palttype_${chatingPlatId}`]" />
                        <!-- <div>
                            {{ msgItem.msg }}
                        </div>

                        <div>
                            <img :src="parseSubMsg(msgItem.submsg).image" alt="">
                            {{ parseSubMsg(msgItem.submsg) }}
                        </div> -->
                    </div>
                </div>

            </div>

            <!-- hello world {{ chatingPlatId }}<br />
            {{ msgItem.isme }}
            <br />
            {{ msgItem }} -->
        </div>
    </div>
</template>
<script>
// 引入动态组件（中间栏）
import { toRefs, onMounted, reactive, computed, provide } from "vue";
import { useStore } from "vuex";
import xiaohsCard from './xiaohs/index.vue'
import douyinCard from './douyin/index.vue'
import {
    revocationMsg
} from "@/api/chatapi";
export default {
    components: { xiaohsCard, douyinCard },
    props: {
        msgItem: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    setup(props) {

        //--------------属性-------------------
        provide('msgItem', props.msgItem)
        let store = useStore();
        const data = reactive({

        });
        //当前选中平台
        const chatingPlatId = computed(() => {
            return store.state.chat_store.chat_plat_id
        });

        const cards = {
            "palttype_2": xiaohsCard,
            "palttype_1": douyinCard
        }

        //--------------方法-------------------

        //--------------生命周期-------------------
        onMounted(() => { });

        return {
            ...toRefs(data),
            chatingPlatId,
            cards,

        };
    },
};
</script>

<style lang="scss" scoped>
.msg_container {
    display: flex;
}

.me.msg_container {
    justify-content: flex-end;
}

.others.msg_container {
    justify-content: flex-start;
}


.card_item {
    // border: 1px solid blue;
    max-width: 535px;
    word-wrap: break-word;
    word-break: break-all;
}

.me .card_item {
    flex-direction: row-reverse;
    align-items: flex-start;
}

.others .card_item {
    align-items: flex-start;
}


.me .card_uname {
    color: #aaa;
    font-size: 12px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: -3px 10px 3px
}

.others .card_uname {
    color: #aaa;
    font-size: 12px;
    display: flex;
    justify-content: flex-start;
    margin: -3px 10px 3px
}

.card_content {
    position: relative;
    background-color: #d6e6f2;
    border-color: #d6e6f2;
    border-radius: 3px;
    padding: 7px 10px;
    font-size: 14px;
}

.me .card_content {
    margin-right: 10px;
}

.others .card_content {
    margin-left: 10px;
}

.card_content_container {
    display: flex;
}

.me .card_content_container {
    display: flex;
    justify-content: flex-end;
}

.otehrs .card_content_container {
    display: flex;
    justify-content: flex-start;
}

.me .card_content {
    justify-content: flex-end;
}

.card_content::after {
    content: '';
    display: inline-block;
    border-width: 5px;
    height: 0;
    width: 0;
    position: absolute;
    top: 10px;
    border-style: solid solid dashed dashed;
    border-color: transparent;
}

.me .card_content::after {
    top: 10px;
    right: -8px;
    border-top-color: inherit;
    border-left-color: inherit;
}

.others .card_content::after {
    top: 10px;
    left: -8px;
    border-top-color: inherit;
    border-right-color: inherit;
}



.others {
    flex-direction: row;
    align-items: flex-start;
}

.avatar {
    flex-shrink: 0;
    overflow: hidden;
    height: 35px;
    width: 35px
}

.avatar img {
    border-radius: 2px;
    vertical-align: top;
    height: 100%;
    width: 100%
}





.lds-ring {
    /* change color here */
    color: #1c4c5b;
    padding: 5px;
}

.lds-ring,
.lds-ring div {
    box-sizing: border-box;
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 16px;
    height: 16px;
    margin: 2px;
    border: 2px solid currentColor;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: currentColor transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>